<template>
  <div id='sub-layout' v-if="program">
    <spinner-round :isLoading="diffusionLoading" v-if="diffusionLoading"></spinner-round>
    <div v-else>
      <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
        <div slot="left">
          <h1 class="title is-3">
            <strong class="">{{program.name}}</strong> - Gestion de la Publication
          </h1>
        </div>
      </sticky>
      <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div v-if="title" id='publicationMessage' class="notification is-primary">
          <a @click="closeMessage" class="close"><i class="fal fa-lg fa-times-circle"></i></a>
          <div class="column is-9 is-paddingless">
            <p class="title is-size-3"><strong>{{title}}</strong></p>
            <p v-if="message">{{message}}</p>
            <a @click="closeMessage" class="button is-white is-outlined is-margin-top">Fermer</a>
          </div>
        </div>
      </transition> -->
      <div class="columns is-gapless has-bg-light is-padding">
        <div class="column is-10 is-9-widescreen is-8-fullhd is-padding-right">
          <div class="is-border-top is-border-left is-border-right has-bg-white">
            <div class="tabs is-separatedUnderlined is-marginless-bottom">
              <ul class="has-text-weight-medium is-borderless">
                <li :class="{'is-active':panel === 'MULTI_DIF'}">
                  <a>Multi diffusion</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="has-bg-white is-border" v-show="panel === 'MULTI_DIF'">
            <div v-if='diffusion && !diffusionLoading' class="has-bg-brand is-padding-left is-padding-right is-margin-top-xsmall">
              <div class="has-text-white is-size-6">
                <span class="icon is-medium is-size-7"><i class="fas fa-check-circle"></i></span>
                <i>Information obligatoire pour la validation du formulaire</i>
              </div>
            </div>
            <form v-if='diffusion && !diffusionLoading' @submit.prevent.stop="submit()">
              <div class="columns is-multiline">
                <div class="column is-12 is-padding-bottom-xsmall is-padding-top-xsmall">
                  <div class="columns is-multiline">
                    <div class="column is-12 title is-3 is-marginless-bottom">
                      <h2 class="is-margin-bottom-xsmall">Paramètre de diffusion</h2>
                      <div class="is-size-4 has-text-grey">Sélectionnez le ou les supports de diffusion de votre annonce</div>
                    </div>
                    <div class="column is-12 is-size-7 has-bg-warning is-padding-small is-radius">
                      <div>Les supports qui remontent sont ceux pour lesquels vous disposez d'un contrat de diffusion. Afin de compléter cette liste, merci de 
                      <a href="mailto:d.appel@mgcpub.com?subject=Demande d'information Multidiffusion Vadimm" class="has-text-grey is-underline">contacter notre partenaire MGC CONNECTING</a>.</div>
                      <div>Le temps de mise en ligne de votre annonce est différent en fonction de support de diffusion. La durée peut varier de 12 à 24 heures<sup>*</sup>.</div>
                    </div>
                    <div class="column is-12">
                      <!-- <label class="label"><i class="fas fa-check-circle" :class="{'has-text-success' : this.diffusion.supports.length !== 0, 'has-text-danger' : !editSupport }"></i> Supports</label> -->
                      <r-label :label="'Supports'" :value="diffusion.supports"></r-label>
                      <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                        <div class="column is-4 is-3-widescreen" v-for="o in origins" :key="o.pk">
                          <input type="checkbox" class="checkradiocase is-fullwidth" v-model="diffusion.supports" :value="o.pk"
                                :name="o.pk" :id="o.pk">
                          <label class="is-nowrap" :for="o.pk"><div class="truncate"><div><span :title="o.name">{{o.name}}</span><span v-if="o.parent_name" :title="o.parent_name">&nbsp;- {{o.parent_name}}</span></div></div></label>
                        </div>
                      </div>
                    </div>
                    <div class="column is-6">
                      <label class="label">Date de début de publication</label>
                      <div class="field has-addons">
                        <div class="control">
                          <a class="button is-square is-static is-border is-min-width-0">
                            <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                          </a>
                        </div>
                        <div class="control is-expanded has-icons-right">
                          <flat-pickr type="date" class="input is-radiusless" v-model="startDate"
                                    :config="configDate"></flat-pickr>
                        </div>
                        <div class="control">
                          <a class="button is-border is-square is-radiusless" @click="startDate = null">
                            <i class="fal fa-times"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="column is-6">
                      <label class="label">Date de fin de publication</label>
                      <div class="field has-addons">
                        <div class="control">
                          <a class="button is-square is-static is-border is-min-width-0">
                            <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                          </a>
                        </div>
                        <div class="control is-expanded has-icons-right">
                          <flat-pickr type="date" class="input is-radiusless" v-model="endDate"
                                    :config="configDate"></flat-pickr>
                        </div>
                        <div class="control">
                          <a class="button is-border is-square is-radiusless" @click="endDate = null">
                            <i class="fal fa-times"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-padding-bottom-xsmall is-12 title is-3 is-marginless-bottom">
                      <h2>Détail de l'annonce</h2>
                    </div>
                  </div>
                  <div class="columns has-bg-light is-border is-multiline">
                    <div class="column is-12">
                      <a @click="addProgramDescriptionsEvent()" :class="addProgramDescriptions ? 'is-success' : 'is-primary'" class="button" v-if="program.descriptions && program.descriptions.length">
                        <span v-if="!addProgramDescriptions">
                          Inclure les textes de description du programme
                        </span>
                        <span v-else>
                          <span class="icon"><i class="fas fa-check"></i></span>
                          <span>Texte de description du programme inclus</span>
                        </span>
                      </a>
                      <div v-else class="has-text-danger is-size-4">Ce programme ne contient pas de description</div>
                    </div>
                    <div class="column is-6">
                      <r-label :label="'Description courte (maximum 255 caractères)'" :value="diffusion.short_description"></r-label>
                      <!-- <label class="label"><i class="fas fa-check-circle" :class="{'has-text-success' : !errors.has('short_description') && this.diffusion.short_description}"></i> Description courte</label> -->
                      <textarea id="short_description" name="short_description" v-model="diffusion.short_description"
                                label="Description courte" data-vv-value-path="val" v-validate="'required'"
                                data-vv-as="Description courte" class="textarea" rows="7" maxlength="255">
                      </textarea>
                    </div>
                    <div class="column is-6">
                      <r-label :label="'Description Longue'" :value="diffusion.long_description"></r-label>
                      <!-- <label class="label"><i class="fas fa-check-circle" :class="{'has-text-success' : !errors.has('long_description') && this.diffusion.long_description}"></i> Description Longue</label> -->
                      <textarea id="long_description" name="long_description" v-model="diffusion.long_description"
                                label="Description longue" data-vv-value-path="val" data-vv-as="Description longue"
                                class="textarea" rows="7" v-validate="'required'">
                      </textarea>
                    </div>
                    <div class="column">
                      <a @click="addProgramPictures" class="button is-primary" v-if="program.pictures && program.pictures.length">
                        Inclure les images du programme
                      </a>
                      <div v-else class="has-text-danger is-size-4">Ce programme ne contient pas d'image</div>
                      <div>
                        <br>
                        <label class="label">Téléchargez des images</label>
                        <upload-file @upload="onPictureUpload" :placeholder="'Sélectionner des image(s)'"
                                    :documents="pictures" :is-image="true" @update="updateDoc" @deleteDocuments="deleteDocuments"></upload-file>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-12 title is-3 is-marginless-bottom is-padding-bottom-xsmall">
                      <h2>Offre commerciale</h2>
                    </div>
                  </div>
                  <div class="columns is-multiline">
                    <div v-for="(offer, idx) in offers" class="column has-bg-light is-12 is-border-top is-border-right is-border-left is-paddingless" :key="idx">
                      <div class="has-text-right">
                        <a class="button is-circle is-border is-margin-right is-margin-neg-top is-white" @click="removeOffer(idx)">
                          <i class="fas fa-trash"></i>
                        </a>
                      </div>
                      <div class="columns is-multiline">
                        <div class="column is-6">
                          <v-input :id="'reference-' + idx" :name="'reference-' + idx" @input="val => offer.reference = val"
                                  :model="offer.reference" placeholder="ex: CNLP"
                                  label="Référence" :errors-bag="errors" data-vv-value-path="val" data-vv-as="Référence">
                          </v-input>
                        </div>
                        <div class="column is-6">
                          <v-input :id="'name-' + idx" :name="'name-' + idx" @input="val => offer.name = val"
                                  :model="offer.name" placeholder="ex: Campagne Nationale Loi Pinel"
                                  label="Nom" :errors-bag="errors" data-vv-value-path="val" data-vv-as="Nom">
                          </v-input>
                        </div>
                        <div class="column is-6">
                          <v-input :id="'start_date-' + idx" :name="'start_date-' + idx"
                                  @input="val => offer.start_date"
                                  :model="offer.start_date" placeholder="ex: Printemps 2018"
                                  label="Date de début" :errors-bag="errors" data-vv-value-path="val"
                                  data-vv-as="Date de début">
                          </v-input>
                        </div>
                        <div class="column is-6">
                          <v-input :id="'end_date-' + idx" :name="'end_date-' + idx" @input="val => offer.end_date = val"
                                  :model="offer.end_date" placeholder="ex: Septembre 2018"
                                  label="Date de fin" :errors-bag="errors" data-vv-value-path="val" data-vv-as="Date de fin">
                          </v-input>
                        </div>
                      </div>
                      <div class="column is-12">
                        <label class="label">Accroche de l'offre</label>
                        <textarea :id="'abstract-' + idx" :name="'abstract-' + idx" v-model="offer.abstract"
                                  label="Accroche" data-vv-value-path="val" data-vv-as="Accroche" class="textarea"
                                  rows="1">
                        </textarea>
                      </div>
                      <div class="column is-12">
                        <label class="label">Description de l'offre</label>
                        <textarea :id="'description-' + idx" :name="'description-' + idx" v-model="offer.description"
                                  label="Description" data-vv-value-path="val" data-vv-as="Description" class="textarea"
                                  rows="3">
                        </textarea>
                      </div>
                      <div class="column is-12">
                        <label class="label">Mentions Légales</label>
                        <textarea :id="'legal_notice-' + idx" :name="'legal_notice-' + idx" v-model="offer.legal_notice"
                                  label="Mentions Légales" data-vv-value-path="val" data-vv-as="Mentions Légales"
                                  class="textarea"
                                  rows="3">
                        </textarea>
                      </div>
                    </div>
                    <div class="column has-bg-light is-border">
                      <a @click="addOffer" class="button is-white is-border is-rounded is-transform-none is-padding-right-large is-padding-left-large">
                        <span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span><span>Ajouter d'une offre promotionnelle</span>
                      </a>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-12 title is-3 is-marginless-bottom is-padding-bottom-xsmall">
                      <h2>Informations de contact</h2>
                    </div>
                  </div>
                  <div class="column is-12 is-size-7 has-text-grey has-bg-warning-lighten-1 is-padding-small is-margin-bottom-xsmall is-radius">
                    <div>Les informations "contacts" sont présentes dans l'annonce sur le support de publication</div>
                  </div>
                  <div class="columns is-multiline has-bg-light is-border">
                    <div class="column is-4">
                      <v-input id="contact" name="contact" @input="val => diffusion.contact = val"
                              :model="diffusion.contact" placeholder="ex: Jacques DUPONT"
                              label="Contact" :errors-bag="errors" data-vv-value-path="val" data-vv-as="Contact">
                      </v-input>
                    </div>
                    <div class="column is-4">
                      <v-input id="schedule" name="contact" @input="val => diffusion.schedule = val"
                              :model="diffusion.schedule" placeholder="ex: De 14h à 20 h du mardi au samedi"
                              label="Horaires" :errors-bag="errors" data-vv-value-path="val" data-vv-as="Horaires">
                      </v-input>
                    </div>
                    <div class="column is-4">

                      <label class="label">Téléphone</label>
                      <the-mask :mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'"
                                v-model="diffusion.contact_tel" @input="val => diffusion.contact_tel = val"
                                id="contactTel" name="contactTel" class="input" />
                    </div>
                    <div class="column is-4">
                      <v-input id="contact_email" name="contact_email" @input="val => diffusion.contact_email = val"
                              :model="diffusion.contact_email" placeholder="ex: j.dupont@contact.fr"
                              label="Email" :errors-bag="errors" data-vv-value-path="val" data-vv-as="Email">
                      </v-input>
                    </div>
                    <div class="column is-12 is-paddingless-right is-paddingless-left is-paddingless-top">
                      <gmap-input @submit="updateAddress" @errorMess='val => errorMess = val ' label="Adresse"
                        name="adresse" :errors-bag="errors" :source="diffusion.contact_address"></gmap-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="formActionsSticky is-bottom">
                <div class="columns column is-12 is-size-7 has-text-grey is-paddingless-bottom has-bg-white">
                  <div class="is-padding-small has-bg-warning-lighten-1 is-radius" style="width: 100%">
                    Vous pouvez enregistrer votre annonce sans la publier. Lorsque toutes les informations necessaires sont renseignées, vous pouvez publier votre annonce.
                    <br/>
                    Vous pouvez stopper la publication à tout moment en cliquant sur "stopper annonce"
                  </div>
                </div>
                <div class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
                  <div class="column is-4 is-3-widescreen is-margin-right-small" v-if='!this.diffusion.enabled'>
                    <a @click="saveBrouillon()" class="button is-success is-uppercase is-fullwidth"
                        :disabled="!canEdit">
                      <span>Enregistrer brouillon</span>
                    </a>
                  </div>
                  <div class="column is-4 is-3-widescreen is-margin-right-small" v-else>
                    <a @click="submitAnnonceModification()" class="button is-success is-uppercase is-fullwidth has-text-white"
                        :disabled="!canSubmit">
                      <span>Publier modifications</span>
                    </a>
                  </div>
                  <div class="column is-4 is-3-widescreen is-margin-right-small" v-if='!this.diffusion.enabled'>
                    <div class="button is-success is-uppercase is-fullwidth has-text-white"
                      :class="{'is-loading':loading}"
                      @click="submitAnnonce()"
                      :disabled="!canSubmit || diffusionLoading">
                      <span v-if="diffusionLoading"><i class="fal fa-spinner-third"></i></span>
                      <span v-else>Publier Annonce</span>
                    </div>
                  </div>
                  <div class="column is-4 is-3-widescreen is-margin-right-small" v-else>
                    <div class="button is-danger is-uppercase is-fullwidth has-text-white"
                      @click="stopAnnonce()">
                      <span>Stopper Annonce</span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueScrollTo from 'vue-scrollto'
  import moment from 'moment'

  const emptyOffer = {
    reference: null,
    name: null,
    abstract: null,
    description: null,
    start_date: null,
    end_date: null
  }

  const emptyDiffusion = {
    enabled: false,
    start_date: null,
    end_date: null,
    add_program_pictures: false,
    add_program_descriptions: false,
    short_description: null,
    long_description: null,
    supports: [],
    disabled: false,
    schedule: null,
    contact: null,
    contact_tel: null,
    contact_email: null,
    contact_address: {
      line1: null,
      zip_code: null,
      city: null
    }
  }
  export default {
    name: 'ProgramDiffusion',
    props: {},
    data () {
      return {
        configDate: {
          // altFormat: 'j/m/Y',
          dateFormat: 'd/m/Y'
        },
        timeout: null,
        diffusionLoading: false,
        originsLoading: false,
        program: null,
        diffusion: {},
        origins: [],
        offers: [],
        pictures: [],
        message: null,
        title: null,
        startDate: null,
        endDate: null,
        addProgramDescriptions: false,
        route: this.$route,
        panel: 'MULTI_DIF',
        annonceStopped: false,
        submitModification: false,
        editSupport: false
      }
    },
    computed: {
      canSubmit () {
        return this.diffusion.short_description && this.diffusion.long_description && this.diffusion.supports.length !== 0
      },
      canEdit () {
        return this.diffusion.supports.length !== 0
      },
      programPk () {
        return this.$route.params.id
      }
    },
    methods: {
      deleteDocuments (document) {
        let idx = this.pictures.findIndex(x => x.filename === document.filename)
        this.pictures.splice(idx, 1)
      },
      updateAddress ({address, location}) {
        this.$set(this.diffusion, 'contact_address', address)
      },
      addProgramDescriptionsEvent () {
        this.addProgramDescriptions = !this.addProgramDescriptions
      },
      saveBrouillon () {
        if (!this.canEdit) return
        this.diffusion.enabled = false
        this.$nextTick(() => {
          this.submit()
        })
      },
      submitAnnonce () {
        if (!this.canSubmit) return
        this.diffusion.enabled = true
        this.$nextTick(() => {
          this.submit()
        })
      },
      submitAnnonceModification () {
        if (!this.canSubmit) return
        this.submitModification = true
        this.diffusion.enabled = true
        this.$nextTick(() => {
          this.submit()
        })
      },
      stopAnnonce () {
        this.annonceStopped = true
        this.diffusion.enabled = false
        this.submit()
      },
      addProgramPictures () {
        this.program.pictures.forEach(picture => {
          this.pictures.push(Object.assign({}, picture))
        })
      },
      addOffer () {
        this.offers.push(Object.assign({}, emptyOffer))
      },
      closeMessage () {
        this.title = null
        this.message = null
      },
      removeOffer (index) {
        this.offers.splice(index, 1)
      },
      getProgram () {
        this.loading = true
        this.$api.programService.getOne(this.programPk).then(res => {
          this.loading = false
          this.program = res.data
        })
      },
      getDiffusion () {
        this.diffusionLoading = true
        this.$api.programService.getOneDiffusion(this.programPk)
          .then(res => {
            this.initDiffusion(res.data)
            this.diffusionLoading = false
          })
          .catch(() => {
            this.diffusion = Object.assign({}, emptyDiffusion)
            this.diffusionLoading = false
          })
      },
      initDiffusion (data) {
        this.diffusion = Object.assign({}, emptyDiffusion, data)
        if (!this.diffusion.contact_address) {
          this.diffusion.contact_address = Object.assign({}, emptyDiffusion.contact_address)
        }
        this.diffusion.enabled = !data.disabled
        this.pictures = data.pictures.slice()
        this.offers = data.offers.slice()
        if (data.start_date) {
          this.startDate = new Date(data.start_date)
        }
        if (data.end_date) {
          this.endDate = new Date(data.end_date)
        }
      },
      loadOrigins () {
        let query = {
          multidiffusion: 1,
          sort: 'name:asc'
        }
        this.originsLoading = false
        this.$api.originService.get(query)
          .then(r => {
            this.origins = r.data
            this.originsLoading = false
          })
          .catch(err => {
            this.originsLoading = false
            console.log(err)
          })
      },
      onPictureUpload (files) {
        if (files.cropped) this.pictures.splice(files.croppedIndex, 1, files[0])
        else files.forEach(el => this.pictures.push(el))
      },
      showMessage (title, message) {
        this.title = title
        this.message = message

        let options = {
          container: 'body',
          offset: -300,
          easing: 'ease-in'
        }

        this.$nextTick(() => {
          VueScrollTo.scrollTo('#publicationMessage', 100, options)
        })

        this.timeout = setTimeout(() => {
          this.closeMessage()
        }, 12000)
      },
      submit () {
        this.diffusionLoading = true
        this.closeMessage()
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.diffusion.disabled = !this.diffusion.enabled
        this.diffusion.offers = this.offers.slice()
        this.diffusion.pictures = this.pictures.slice()
        if (this.diffusion.start_date === '') {
          this.diffusion.start_date = null
        }
        if (this.startDate && this.startDate !== '') {
          this.diffusion.start_date = this.startDate
        } else {
          this.diffusion.start_date = null
        }
        if (this.endDate && this.endDate !== '') {
          this.diffusion.end_date = this.endDate
        } else {
          this.diffusion.end_date = null
        }
        this.diffusion.add_program_descriptions = this.addProgramDescriptions
        this.$api.programService.postDiffusion(this.programPk, this.diffusion)
          .then(res => {
            this.initDiffusion(res.data)
            this.diffusionLoading = false
            let message = null
            let title = null
            let start = null
            let end = null
            if (!res.data.disabled) {
              if (this.submitModification) {
                this.$notify({
                  type: 'is-success',
                  text: 'Modification enregistrée. Votre annonce sera actualisée sur le ou les support(s) dans un délais pouvant aller jusqu\'a 12 heures',
                  duration: 5000
                })
                this.submitModification = false
              } else {
                title = 'Publication validée.'
                if (res.data.start_date) {
                  start = moment(res.data.start_date).format('DD MMMM')
                }
                if (res.data.end_date) {
                  end = moment(res.data.end_date).format('DD MMMM')
                }
                if (start && end) {
                  message = `Votre annonce sera consultable sur le ou les support(s) dans la journée du ${start} au ${end}`
                } else if (start) {
                  message = 'Votre annonce sera consultable sur le ou les support(s) à partir de la journée du ' + start
                } else if (end) {
                  message = 'Votre annonce sera consultable sur le ou les support(s) jusqu\'au ' + end
                } else {
                  let tomorow = moment().add(1, 'day').format('DD MMMM')
                  message = 'Votre annonce sera consultable sur le ou les support(s) dans la journée du ' + tomorow
                }
                this.$notify({
                  type: 'is-success',
                  text: title + '\n' + message,
                  duration: 5000
                })
              }
            } else if (this.annonceStopped) {
              this.$notify({
                type: 'is-success',
                text: 'Publication stoppée'
              })
              this.annonceStopped = false
            } else {
              this.$notify({
                type: 'is-success',
                text: 'Annonce sauvegardée en tant que brouillon.',
                duration: 5000
              })
            }
            this.showMessage(title, message)
          })
          .catch(err => {
            console.log(err)
            this.diffusionLoading = false
            this.$notify({
              type: 'is-danger',
              text: 'Impossible d\'enregistrer la publication..'
            })
          })
      }
    },
    created () {
      this.getProgram()
      this.getDiffusion()
      this.loadOrigins()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/ProgramDiffusionEdit.vue